import React from "react"
import styled, { keyframes } from "styled-components"
import { rhythm } from "../utils/typography"
import Link from "gatsby-link"

const ChillyWrapper = styled.div`
  right: 1rem;
  bottom: 1rem;
  position: fixed;
`

const Head = styled.div`
  height: ${rhythm(3)};
  width: ${rhythm(3)};
  overflow: hidden;
  transition: width .5s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    height .5s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    border-radius .25s;
  background-color: #add8e6;
  position: relative;
  border-radius: ${rhythm(1.5)};
  box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14),
    0 1px 10px 0 rgba(0,0,0,0.12),
    0 2px 4px -1px rgba(0,0,0,0.3);

  &:hover {
    filter: brightness(1.05);
  }

  & {
    cursor: pointer;
  }

  &[data-sleeping='true'] {
    height: ${rhythm(2.5)};
    border-radius: ${rhythm(1.5)} ${rhythm(1.5)} ${rhythm(.5)} ${rhythm(.5)};
    transition: height 1s, border-radius 1s;
    transform-origin: bottom;
    animation: breathing 3s ease-out 1s infinite alternate;
  }

  @keyframes breathing {
    from {
      transform: scale3d(1, 1, 1);
      border-radius: ${rhythm(1.5)} ${rhythm(1.5)} ${rhythm(.5)} ${rhythm(.5)};
    }
    to {
      transform: scale3d(1.02, 0.9, 1);
      border-radius: ${rhythm(1.5)} ${rhythm(1.5)} ${rhythm(.3)} ${rhythm(.3)};
    }
  }
`

const Eyes = styled.div`
  width: ${rhythm(1.5)};
  margin: 0 auto;
  right: 0;
  position: relative;
  transition: transform .5s cubic-bezier(.02,.91,.71,1);
`

const fallAsleep = keyframes`
  from {
    top: ${rhythm(-.75)};
  }
  to {
    top: ${rhythm(-.1)};
  }
`

const LeftEye = styled.div`
  width: ${rhythm(.5)};
  height: ${rhythm(1)};
  top: ${rhythm(1)};
  background-color: #2ac;
  border-radius: 50%;
  position: absolute;

  &[data-sleeping='false'][data-blinking='true'] {
    animation: blink-left 10s infinite;
  }

  @keyframes blink-left {
    0% {
      height: ${rhythm(1)};
      width: ${rhythm(.5)};
      left: 0;
      top: ${rhythm(1)};
    }
    0.5% {
      height: ${rhythm(.25)};
      width: ${rhythm(.8)};
      left: ${rhythm(-.15)};
      top: ${rhythm(1.75)};
    }
    2.5% {
      height: ${rhythm(1)};
      width: ${rhythm(.5)};
      left: 0;
      top: ${rhythm(1)};
    }
  }

  &[data-sleeping='true']:after {
    position: relative;
    content: " ";
    display: block;
    border-radius: 50%;
    width: ${rhythm(.5)};
    height: ${rhythm(.75)};
    animation: ${fallAsleep} 1s forwards;
    background-color: #add8e6;
  }

  &[data-open='true']:after {
    position: relative;
    content: " ";
    display: block;
    border-radius: 50%;
    width: ${rhythm(.5)};
    height: ${rhythm(.5)};
    top: ${rhythm(.7)};
    background-color: #add8e6;
  }
`

const RightEye = styled.div`
  width: ${rhythm(.5)};
  height: ${rhythm(1)};
  top: ${rhythm(1)};
  right: 0;
  background-color: #2ac;
  border-radius: 50%;
  position: absolute;

  &[data-sleeping='false'][data-blinking='true'] {
    animation: blink-right 10s infinite;
  }

  @keyframes blink-right {
    0% {
      height: ${rhythm(1)};
      width: ${rhythm(0.5)};
      right: 0;
      top: ${rhythm(1)};
    }
    0.5% {
      height: ${rhythm(.25)};
      width: ${rhythm(.8)};
      right: ${rhythm(-.15)};
      top: ${rhythm(1.75)};
    }
    2.5% {
      height: ${rhythm(1)};
      width: ${rhythm(0.5)};
      right: 0;
      top: ${rhythm(1)};
    }
  }

  &[data-sleeping='true']:after {
    position: relative;
    content: " ";
    display: block;
    border-radius: 50%;
    width: ${rhythm(.5)};
    height: ${rhythm(.75)};
    animation: ${fallAsleep} 1s forwards;
    background-color: #add8e6;
  }

  &[data-open='true']:after {
    position: relative;
    content: " ";
    display: block;
    border-radius: 50%;
    width: ${rhythm(.5)};
    height: ${rhythm(.5)};
    top: ${rhythm(.7)};
    background-color: #add8e6;
  }
`

const Links = styled.div`
  bottom: ${rhythm(4)};
  right: 1rem;
  text-align: center;
  position: fixed;
  transition: visibility 0s .2s, opacity .2s;
  visibility: hidden;
  opacity: 0;
  font-size: 3rem;

  &[data-open='true'] {
    transition: opacity .5s;
    transition-delay: .5s;
    visibility: visible;
    opacity: 1;
  }

  a:link {
    color: steelblue;
    text-decoration: none;
  }

  a:visited {
    color: steelblue;
  }

  a:hover {
    text-decoration: underline;
  }
`

class Chilly extends React.Component {
  constructor() {
    super()
    this.state = {
      leftEyeBlinking: true,
      rightEyeBlinking: true,
      sleeping: false
    }
    this.timer = this.timer.bind(this)
    this.refreshTimer = this.refreshTimer.bind(this)
    this.sleepCount = 30
  }

  componentDidMount() {
    this.timerInterval = setInterval(this.timer, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.timerInterval)
  }

  timer() {
    if (this.sleepCount && !this.props.open) this.sleepCount--
    else if (!this.state.sleeping && !this.props.open) this.setState({
      sleeping: true
    })
  }

  refreshTimer() {
    this.sleepCount = 30
    this.setState({
      sleeping: false
    })
  }

  render() {
    console.log(this.state)
    return (
      <div>
        <Links
          data-open={this.props.open}
        >
          {this.props.links.map((obj, i) => (
            <div key={i}>
              <Link onClick={this.props.onClick} to={obj.fields.slug}>{obj.frontmatter.title}</Link>
            </div>
          ))}
        </Links>
        <ChillyWrapper onClick={this.props.onClick}>
          <Head
            data-sleeping={this.state.sleeping}
            data-open={this.props.open}
            onMouseOver={this.refreshTimer}
            linksLength={this.props.links.length}
          >
            <Eyes>
              <LeftEye
                data-sleeping={this.state.sleeping}
                data-open={this.props.open}
                data-blinking={this.state.leftEyeBlinking}
              />
              <RightEye
                data-sleeping={this.state.sleeping}
                data-open={this.props.open}
                data-blinking={this.state.rightEyeBlinking}
              />
            </Eyes>
          </Head>
        </ChillyWrapper>
      </div>
    )
  }
}

export default Chilly


// WEBPACK FOOTER //
// ./src/components/Chilly.js